module.exports = __webpack_public_path__ + "static/media/mine-banner.2dce522d.png";